import ModuleLoadingSpinner from './ModuleLoadingSpinner'

export default ModuleLoadingSpinner



// WEBPACK FOOTER //
// ./src/components/UI/ModuleLoadingSpinner/index.js